export default "__VITE_ASSET__Cn$CbMdW__"